<template>
	<div class="content" >

		<div class="page">
			<div class="container">
				<div v-if="mode !== 'search' && mode !== 'contact'">
					<p v-if="headTitle" class="head-title" v-html="headTitle">

					</p>
					<div v-for="item in listedContent" class="question">

						<p v-if="mode==='faqs'" class="section-title" >
							<!-- {{item.sectionTitle}} -->
						</p>
						<input type="checkbox" :id="item.id" v-model="openTarget[item.id]"/>
						<label :for="item.id"><p class="content-title" v-html="item.title"  >

						</p></label>

						<p v-html="item.body" class="question-body">

						</p>
					</div>
				</div>
				<div v-if="mode === 'search'">
					<div class="search-title">
						<span v-html="l10.All_FAQ_Body_Title1_Description2"> </span>
						<div v-for="word in searchWordList" class="searched-word">
							<span v-html="word"></span>
							<div class="remove" @click="$emit('removeWord', word)">

							</div>
						</div>
					</div>
					<div v-if="listedContent.length == 0" v-html="l10.All_FAQ_Body_Title1_Description3">

					</div>
					<div v-for="item in listedContent" class="question">

						<input type="checkbox" :id="item.id" v-model="openTarget[item.id]"/>
						<label :for="item.id"><p class="content-title" v-html="item.title"  >

						</p></label>
						<p v-html="item.body" class="question-body">

						</p>
					</div>
				</div>

				<div class="contact-form" v-if="mode === 'contact'">
					<p class="head-title" v-html="l10.All_FAQ_tab2_Title1">

					</p>

					<div :class="[contactUsForm.error.email]">
						<p class="email">
							<span v-html="l10.All_FAQ_Body_Title2_Subtitle1"></span>
							<span v-if="contactUsForm.error.email ==='blank-error'" class="error-text">* Response required</span>
							<span v-if="contactUsForm.error.email ==='form-error'" class="error-text">not email</span>
						</p>
						<input id="email" @blur="checkEmail()" v-model="contactUsForm.value.email" type="text" placeholder="example@email.com" />
					</div>
					<div :class="{'blank-error':contactUsForm.error.subject}">
						<p class="email">
							<span v-html="l10.All_FAQ_Body_Title2_Subtitle2"></span>
							<span v-if="contactUsForm.error.subject ==='blank-error'" class="error-text">* Response required</span>
						</p>
						<input type="text" v-model="contactUsForm.value.subject" :placeholder="l10.All_FAQ_Body_Title2_Subtitle2_Description1" />
					</div>
					<div :class="{'blank-error':contactUsForm.error.subject}">
						<p class="email">
							<span  v-html="l10.All_FAQ_Body_Title2_Subtitle3"></span>
							<span v-if="contactUsForm.error.description ==='blank-error'" class="error-text">* Response required</span>
						</p>
						<textarea v-model="contactUsForm.value.description" :placeholder="l10.All_FAQ_Body_Title2_Subtitle3_Description1"></textarea>
					</div>
					<div>
						<div class="submit-btn" @click="sendEmail()">
							<span v-html="l10.All_FAQ_Body_Title2_Button1"></span>
						</div>
					</div>
				</div>
				<div v-if="mode !== 'contact'" class="move-contact">
					<router-link to="/help/contact" v-html="l10.All_FAQ_Body_Title1_Button1"></router-link>
				</div>



			</div>


		</div>


	</div>

</template>
<script>




export default {
  name: 'Help',
	props:['mode','generalFaqs','schoolFaqs','listedContent','headTitle','l10', 'contactUsForm',  'subTitle', "openTarget"],
	components:{ },
	methods:{
		checkEmail(){
			this.$emit('checkEmail');
		},
		sendEmail(){
			this.$emit('sendEmail');

		},
		toggleFaqArea($event, id){
			$event.target.classList.toggle('open');
			this.openTarget[id] = this.openTarget[id] ? '':'open';
		},
		initContentTitleClass(id){
			if( typeof(this.openTarget[id]) == "undefined"){
				return 'content-title'
			}else{
				return 'content-title ' + this.openTarget[id];
			}
		}
	},
	data () {

	    return {


				checkboxInit:{},
				lang:this.$store.state.lang
				// contactUsForm:{value:{email:'',subject:'',description:''}, error:{email:'',subject:false,description:false}}
	    }
	},
	watch:{
		$route(to, from){
			this.submenuCtrl = false;
		}

	}
}


</script>

<style  scoped>
.content{
	width:100%;
	overflow: hidden;

	min-height: 100vh;
}

.container{
	margin: 0 auto;
	height: auto;
	min-height: 100px;
	width:720px;
	padding: 0 35px;
}

.page {
	padding:36px 0;
	padding-top:68px;
		background-color: #fffcf7;
		padding-bottom: 200px;
		min-height: 600px;

}
.head-title{
	margin-bottom: 60px;
	font-size: 48px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.67;
  letter-spacing: -1.9px;
  color: #41403e;
}
.section-title{
	font-size: 28px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.36;
  letter-spacing: -0.8px;
  color: #999999;
	margin-bottom: 10px;
}
.content-title{

	font-size: 34px;
 font-weight: bold;
 font-style: normal;
 font-stretch: normal;
 line-height: 1.35;
 letter-spacing: -1px;
 color: #41403e;
  width:100%;
}
.question ~ .question{
	margin-top:80px;
}

.question>.content-title{
	/* padding-left:32.5px; */
	position: relative;
}
/* .question>.content-title::before{
	content:url('../../assets/help/img-btn-arrow-wh.svg');
	position: absolute;
	top:-2px;
	left:0;
	width:32.5px;
} */
.question>input[type=checkbox]{
	display: none;
}
/* .question>.content-title.open::before{
	content:url('../../assets/help/img-faq-arrow-down-bl.svg');
	top:0px;
} */
.question>.content-title:hover{
	cursor: pointer;
}
.question>.question-body{
	display: none;
	margin-top:48px;
	padding-bottom:120px;
	border-bottom: 1px solid #e6e6e6;
	width:100%;
	font-size: 28px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.36;
  letter-spacing: -1px;
  color: #41403e;
}
.question>label{
	display: block;
}
.question>label[for]:hover{
	cursor: pointer;
}
.question>input[type=checkbox]:checked ~ .question-body{
	display: block;
}

.contact-form{
	font-size: 28px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.36;
  letter-spacing: -1px;
  color: #41403e;
}
.contact-form>div~div{
	margin-top:38px;
}
.contact-form>div>input[type=text], .contact-form>div>textarea{
	display: block;
	padding: 31px 28px;
	border: solid 1px #e6e6e6;
  background-color: #ffffff;
  border-radius: 8px;
  margin-top:12px;
  font-size: 18px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: -0.4px;

  width: 100%;

}
.contact-form>div>textarea{
	resize: vertical;
	min-height: 518px;
}



input:focus, textarea:focus{
	 outline: none !important;
}
.contact-form .blank-error>input[type=text], .form-error>input[type=text], .blank-error>textarea{
	border: solid 2px #f77f73 !important;
}
.contact-form .error-text{
	font-size: 28px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: -0.6px;
  color: #f77f73;

}
.contact-form>div:last-of-type{
	display: block;
}
.contact-form .submit-btn{
	width: 100%;
	height: 100px;
 border-radius: 50px;
	border: solid 3px #42c0ff;
display: flex;
justify-content: center;
font-size: 28px;
font-weight: bold;
font-style: normal;
font-stretch: normal;
line-height: normal;
letter-spacing: -1.3px;
text-align: center;

 color: #42c0ff;
 align-items: center;

}
.contact-form .submit-btn:hover{
	cursor: pointer;
}

a.router-link-active{
	font-weight: bold;
	font-size: 28px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: -0.6px;
  color: #42c0ff;

}
.move-contact{
	border-top:solid 2px #e6e6e6;
	margin-top:80px;
	padding-top:36px;
	font-size: 28px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: -1px;

  color: #42c0ff;
}
</style>



// WEBPACK FOOTER //
// src/pages/help/HelpMobile.vue